import Breadcrumb from "components/Common/Breadcrumb2"
import toast from "components/Toast/Toast"
import { useFormik } from "formik"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import { useHistory, useParams } from "react-router-dom"
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap"
import { getOne, getStatus, updateOne } from "services/shipping-companies/calls"
import "simplebar-react/dist/simplebar.min.css"
import * as Yup from "yup"

const UpdateEvento = props => {
  document.title = "Eventos | Sensetek"

  const { id } = useParams()

  const { idt } = useParams()

  const [isLoading, setLoading] = useState(true)
  const [statuses, setStatuses] = useState([])
  const [submitting, setSubmitting] = useState([])
  const [shippingEvent, setShippingEvent] = useState([])

  const history = useHistory()

  useEffect(() => {
    fetchStatuses()
    fetchShippingEvent(id)
    setLoading(false)
  }, [id])

  const fetchStatuses = async () => {
    try {
      const payload = await getStatus()
      setStatuses(payload)
    } catch (err) {
      console.log(err)
    }
  }

  const fetchShippingEvent = async id => {
    try {
      const shippingEventList = await getOne(id)
      const shippingEvent = shippingEventList[0]
      shippingEvent.newStatusName = ""
      setShippingEvent({ ...shippingEvent })
    } catch (err) {
      console.log(err)
    }
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      externalEventId: shippingEvent.externalEventId,
      eventName: shippingEvent.eventName,
      statusName: shippingEvent.statusName,
      newStatusName: "",
    },
    validationSchema: Yup.object().shape({}),
    onSubmit: values => {
      const status = statuses.find(sts => sts.name == values.newStatusName)
      if (!status) return
      shippingEvent.statusId = Number(status.id)
      shippingEvent.newStatusName = status.name
      setShippingEvent({
        ...shippingEvent,
      })
      onSubmitStatus()
    },
  })

  const onSubmitStatus = async () => {
    try {
      const { eventId, ...payload } = shippingEvent
      setSubmitting(true)
      await updateOne(eventId, payload)
      setSubmitting(false)
      toast("success", "Status atualizado com sucesso.", "")
      history.push(`/configuracoes/params/transportadoras/${idt}`)
    } catch (error) {
      console.log(error)
      toast("warning", error?.message, "Aviso")
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={props.t("Configurações")}
            breadcrumbItems={[{ title: props.t("Eventos"), path: "#" }]}
          />
          <Row>
            <Col>
              <Card>
                <CardHeader tag={"h4"} className="bg-transparent border-bottom">
                  {`Atualização de Evento: ${shippingEvent.companyName}`}
                </CardHeader>
                <CardBody>
                  <br className="mt-1" />
                  {isLoading && (
                    <div className="mt-3" style={{ textAlign: "center" }}>
                      <Spinner className="ms-2" color="primary" />
                    </div>
                  )}
                  {!isLoading && (
                    <Row>
                      <Col>
                        <Form
                          className="form-horizontal"
                          onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                          }}
                        >
                          <Row>
                            <Col>
                              <FormGroup>
                                <Label>Código do Evento</Label>
                                <Input
                                  name={"externalEventId"}
                                  type="text"
                                  readOnly={true}
                                  className="form-control"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={
                                    validation.values.externalEventId || ""
                                  }
                                  invalid={
                                    validation.touched.externalEventId &&
                                    validation.errors.externalEventId
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.externalEventId &&
                                validation.errors.externalEventId ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.externalEventId}
                                  </FormFeedback>
                                ) : null}
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <Label>Nome Evento</Label>
                                <Input
                                  name={"eventName"}
                                  type="text"
                                  readOnly={true}
                                  className="form-control"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.eventName || ""}
                                  invalid={
                                    validation.touched.eventName &&
                                    validation.errors.eventName
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.eventName &&
                                validation.errors.eventName ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.eventName}
                                  </FormFeedback>
                                ) : null}
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={6}>
                              <FormGroup>
                                <Label>Status Atual Relacionado</Label>
                                <Input
                                  name={"statusName"}
                                  type="text"
                                  readOnly={true}
                                  className="form-control"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.statusName || ""}
                                  invalid={
                                    validation.touched.statusName &&
                                    validation.errors.statusName
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.statusName &&
                                validation.errors.statusName ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.statusName}
                                  </FormFeedback>
                                ) : null}
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <FormGroup>
                                <Label>Novo Status</Label>
                                <Input
                                  name={"newStatusName"}
                                  type="select"
                                  readOnly={true}
                                  className="form-control"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.newStatusName || ""}
                                  invalid={
                                    validation.touched.newStatusName &&
                                    validation.errors.newStatusName
                                      ? true
                                      : false
                                  }
                                >
                                  <option value={""}>
                                    Selecione o novo status
                                  </option>
                                  {statuses.map(status => (
                                    <option
                                      value={status.name}
                                      key={`status-${status.id}`}
                                    >
                                      {status.name}
                                    </option>
                                  ))}
                                </Input>
                                {validation.touched.newStatusName &&
                                validation.errors.newStatusName ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.newStatusName}
                                  </FormFeedback>
                                ) : null}
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            {isLoading && (
                              <div
                                className="mt-3"
                                style={{ textAlign: "center" }}
                              >
                                <Spinner className="ms-2" color="primary" />
                              </div>
                            )}
                            {!isLoading && (
                              <div className="mt-3 d-grid">
                                <button
                                  className="btn btn-primary btn-block"
                                  type="submit"
                                >
                                  Editar
                                </button>
                              </div>
                            )}
                          </Row>
                        </Form>
                      </Col>
                    </Row>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

UpdateEvento.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(UpdateEvento)
